<div *ngIf="!isReadOnly; else readOnly" class="product-price-container">
  <dynamic-form *ngIf="dynamicForm" [formConfig]="dynamicForm"></dynamic-form>
</div>
      
<ng-template #readOnly class="readOnly">
  <div fxLayout="column" fxLayoutAlign="start start">
    <div class="icon-container">
      <mat-icon color="primary" [svgIcon]="readOnlyData.icon"></mat-icon>
    </div>

    <div *ngIf="status.showInfo" class="statusContainer" [ngClass]="status.backgroundColorClass">
      <p>{{status.text}}</p>
    </div>

    <h1 class="object-name-readOnly">{{readOnlyData.name}}</h1>
    <h2 class="object-price-readOnly">{{readOnlyData.price | currency: 0 : '€' }}</h2>
  </div>
  
</ng-template>
